import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getOrders, createOrder, deleteOrder, getSites } from '../api';

export default function OrdersPage() {
  const [orders, setOrders] = useState([]);
  const [sites, setSites] = useState([]);
  const [showCreate, setShowCreate] = useState(false);
  const [form, setForm] = useState({ CustomerName: '', SiteId: '', HubSpotDealId: '', Notes: '' });
  const navigate = useNavigate();

  const loadOrders = () => {
    Promise.all([getOrders(), getSites()])
      .then(([o, s]) => { setOrders(o.data); setSites(s.data); })
      .catch(console.error);
  };

  useEffect(loadOrders, []);

  const handleCreate = async (e) => {
    e.preventDefault();
    try {
      const res = await createOrder(form);
      setShowCreate(false);
      setForm({ CustomerName: '', SiteId: '', HubSpotDealId: '', Notes: '' });
      navigate(`/orders/${res.data.OrderId}`);
    } catch (err) {
      alert('Error creating order: ' + (err.response?.data?.error || err.message));
    }
  };

  const handleDelete = async (e, orderId) => {
    e.stopPropagation();
    if (!window.confirm('Delete this order?')) return;
    try {
      await deleteOrder(orderId);
      loadOrders();
    } catch (err) {
      alert('Error: ' + err.message);
    }
  };

  return (
    <>
      <div className="top-header">
        <h1>Orders</h1>
        <div className="top-header-actions">
          <button className="hs-btn hs-btn-primary" onClick={() => setShowCreate(true)}>
            + Create Order
          </button>
        </div>
      </div>
      <div className="page-content">
        <div className="hs-card">
          <table className="hs-table">
            <thead>
              <tr>
                <th>Order #</th>
                <th>HubSpot Deal</th>
                <th>Customer</th>
                <th>Site</th>
                <th>Status</th>
                <th>Lines</th>
                <th className="text-right">Total</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {orders.length === 0 ? (
                <tr><td colSpan="8">
                  <div className="empty-state">
                    <div className="empty-icon">📋</div>
                    <h3>No orders yet</h3>
                    <p>Create your first order to get started</p>
                    <button className="hs-btn hs-btn-primary mt-md" onClick={() => setShowCreate(true)}>+ Create Order</button>
                  </div>
                </td></tr>
              ) : (
                orders.map(order => (
                  <tr key={order.OrderId} className="clickable" onClick={() => navigate(`/order-editor?orderId=${order.OrderId}`)}>
                    <td><strong>{order.OrderNumber}</strong></td>
                    <td><span className="text-muted font-mono text-sm">{order.HubSpotDealId || '—'}</span></td>
                    <td>{order.CustomerName}</td>
                    <td>{order.Site?.SiteName || '—'}</td>
                    <td><span className={`hs-badge hs-badge-${order.Status.toLowerCase()}`}>{order.Status}</span></td>
                    <td>{order.LineCount}</td>
                    <td className="text-right font-mono">£{order.TotalAmount?.toFixed(2)}</td>
                    <td>
                      <button className="hs-btn hs-btn-sm hs-btn-danger" onClick={(e) => handleDelete(e, order.OrderId)}>×</button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* Create Order Modal */}
      {showCreate && (
        <div className="hs-modal-overlay" onClick={() => setShowCreate(false)}>
          <div className="hs-modal" onClick={e => e.stopPropagation()}>
            <div className="hs-modal-header">
              <h3>Create New Order</h3>
              <button className="hs-modal-close" onClick={() => setShowCreate(false)}>×</button>
            </div>
            <form onSubmit={handleCreate}>
              <div className="hs-modal-body">
                <div className="hs-form-row">
                  <div className="hs-form-group">
                    <label>Customer Name *</label>
                    <input className="hs-input" required value={form.CustomerName}
                      onChange={e => setForm({...form, CustomerName: e.target.value})}
                      placeholder="e.g. Acme Corporation" />
                  </div>
                  <div className="hs-form-group">
                    <label>Franchise Site *</label>
                    <select className="hs-select" required value={form.SiteId}
                      onChange={e => setForm({...form, SiteId: e.target.value})}>
                      <option value="">Select site...</option>
                      {sites.map(s => <option key={s.SiteId} value={s.SiteId}>{s.SiteName} ({s.SiteCode})</option>)}
                    </select>
                  </div>
                </div>
                <div className="hs-form-group">
                  <label>HubSpot Deal ID</label>
                  <input className="hs-input" value={form.HubSpotDealId}
                    onChange={e => setForm({...form, HubSpotDealId: e.target.value})}
                    placeholder="e.g. HS-DEAL-12345" />
                </div>
                <div className="hs-form-group">
                  <label>Notes</label>
                  <textarea className="hs-textarea" value={form.Notes}
                    onChange={e => setForm({...form, Notes: e.target.value})}
                    placeholder="Any additional notes..." />
                </div>
              </div>
              <div className="hs-modal-footer">
                <button type="button" className="hs-btn hs-btn-secondary" onClick={() => setShowCreate(false)}>Cancel</button>
                <button type="submit" className="hs-btn hs-btn-primary">Create Order</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </>
  );
}
